<template>
    <div class="stock-create">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.go(-1);">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="top-navbar-center">Create Stock Purchase / Transfer</div>
                    </div>
                </div>
            </div>

            <hr />
        </div>

        <div class="container mt-5">
            
            <form action="">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Type of Stock In *</label>
                            <div>
                                <div class="custom-control-inline pill-radio">
                                    <input id="purchase" type="radio" name="stock-type" value="1" required class="custom-control-input" checked>
                                    <label class="" for="purchase" @click="showPurchaseForm">Purchase</label>
                                </div>
                                <div class="custom-control-inline pill-radio">
                                    <input id="transfer" type="radio" name="stock-type" value="0" required class="custom-control-input">
                                    <label class="" for="transfer" @click="showTransferForm">Transfer</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Week</label>
                            <input class="form-control-plaintext" type="text" value="Week 29 (8-14 Nov)" readonly>
                        </div>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table table-striped result-table table-form">
                        <thead>
                            <tr>
                                <th></th>
                                <th class="w-15">Brand</th>
                                <th class="w-20">Product</th>
                                <th class="w-10">QTY</th>
                                <th class="text-right">Purchase Price Per Unit</th>
                                <th class="text-right">Total Purchase Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="remove-row">Remove</div>
                                </td>
                                <td>
                                    <select class="custom-select form-control" name="brand" id="brand" required>
                                        <option>Dunhill</option>
                                    </select>
                                </td>
                                <td>
                                    <select class="custom-select form-control" name="product" id="product" required>
                                        <option>Dunhill</option>
                                    </select>
                                </td>
                                <td>
                                    <input class="form-control" type="number" value="1" required>
                                </td>
                                <td>
                                    <input class="form-control text-right" type="text" required>
                                </td>
                                <td class="text-right">
                                    <span>23,000</span>
                                </td>
                            </tr>


                            <tr class="table-footer">
                                <td colspan="3">
                                    <button type="button" class="btn btn-link p-0">
                                        <span class="icon-plus">Add</span> Add Product
                                    </button>
                                </td>
                                <td colspan="2" class="text-right">Grand Total Purchase Price</td>
                                <td class="text-right">80,000</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <hr>
                
                <div v-if="showPurchaseStatus">

                    <h3 class="section-title mt-5">Purchase For</h3>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Division *</label>

                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input type="radio" id="north" name="division" value="0" required class="custom-control-input">
                                        <label class="" for="north">North</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input type="radio" id="south" name="division" value="1" required class="custom-control-input">
                                        <label class="" for="south">South</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Region *</label>
                                <select class="custom-select form-control" name="region" id="region" required>
                                    <option></option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Area *</label>
                                <select class="custom-select form-control" name="area" id="area" required>
                                    <option></option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Source</label>
                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input id="asmo" type="radio" name="source" value="1" required class="custom-control-input">
                                        <label class="" for="asmo">ASMO</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input id="distributor" type="radio" name="source" value="2" required class="custom-control-input">
                                        <label class="" for="distributor">Distributor</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input id="wholesales" type="radio" name="source" value="3" required class="custom-control-input">
                                        <label class="" for="wholesales">Wholesales</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input id="cash" type="radio" name="source" value="4" required class="custom-control-input">
                                        <label class="" for="cash">Cash</label>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Invoice Date</label>
                                <datepicker format="yyyy-MM-dd"></datepicker>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Invoice Number</label>
                                <input class="form-control" type="text" required>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="profile_image">Invoice Photo</label> 
                                <input id="profile_image" type="file" @change="uploadProfileImage()" hidden>

                                <label for="profile_image" class="image-upload user-photo"  :class="{ 'uploaded': profile_image_preview }">
                                    <div class="btn btn-ecdc">Browse</div>
                                    <img v-if="profile_image_preview" :src="profile_image_preview" alt=""> 
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="">Remarks</label>
                        <textarea name="remarks" id="remarks" rows="3" class="form-control"></textarea>
                    </div>
                </div>

                <div v-if="showTransferStatus">

                    <h3 class="section-title mt-5">Transfer From</h3>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Division *</label>

                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input type="radio" id="north" name="division" value="0" required class="custom-control-input">
                                        <label class="" for="north">North</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input type="radio" id="south" name="division" value="1" required class="custom-control-input">
                                        <label class="" for="south">South</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Region *</label>
                                <select class="custom-select form-control" name="region" id="region" required>
                                    <option></option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Area *</label>
                                <select class="custom-select form-control" name="area" id="area" required>
                                    <option></option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="profile_image">Photo of Transfer Form</label> 
                                <input id="profile_image" type="file" @change="uploadProfileImage()" hidden>

                                <label for="profile_image" class="image-upload user-photo"  :class="{ 'uploaded': profile_image_preview }">
                                    <div class="btn btn-ecdc">Browse</div>
                                    <img v-if="profile_image_preview" :src="profile_image_preview" alt=""> 
                                </label>
                            </div>
                        </div>
                    </div>

                    <hr>


                    <h3 class="section-title mt-5">Transfer To</h3>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Project</label>
                                <select class="custom-select form-control" name="project" id="project" required>
                                    <option>121</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Division *</label>

                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input type="radio" id="north" name="division" value="0" required class="custom-control-input">
                                        <label class="" for="north">North</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input type="radio" id="south" name="division" value="1" required class="custom-control-input">
                                        <label class="" for="south">South</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Region *</label>
                                <select class="custom-select form-control" name="region" id="region" required>
                                    <option></option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Area *</label>
                                <select class="custom-select form-control" name="area" id="area" required>
                                    <option></option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="">Remarks (Including Programme to programme)</label>
                        <textarea name="remarks" id="remarks" rows="3" class="form-control"></textarea>
                    </div>

                </div>

                <button type="submit" class="mt-3 btn btn-ecdc btn-shadow">Create</button>
            </form>

        </div>

        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
    data() {
        return {
            showPurchaseStatus:true,
            showTransferStatus:false
        }
    },
    methods: {
        showPurchaseForm() {
            this.showPurchaseStatus = true;
            this.showTransferStatus = false;
        },
        showTransferForm() {
            this.showPurchaseStatus = false;
            this.showTransferStatus = true;
        },
    },
    components: {
        Datepicker
    },
}
</script>